import React from 'react'

const NoElection = ({data}) => {
  return (
    <div style={{color:"orange", textAlign:"center",marginTop:"60px",fontSize:"26px",fontWeight:"500"}}>{data}</div>
  )
}

export default NoElection